export function nullIfBlank(value: string | null | undefined): string | null {
  return value?.trim() ? value : null;
}
